import { createAction, createReducer } from '@reduxjs/toolkit'

const initialState = {
  travelCardAmount: null,
  loyaltyPointAmount: null,
}

export const handleTravelCardAmount = createAction('cart/setTravelCardAmount')

export const handleLoyaltyPointsAmount = createAction(
  'cart/setLoyaltyPointsAmount',
)

export const cartReducer = createReducer(initialState, builder => {
  builder
    .addCase(handleTravelCardAmount, (state, action) => ({
      ...state,
      travelCardAmount: action.payload,
    }))
    .addCase(handleLoyaltyPointsAmount, (state, action) => ({
      ...state,
      loyaltyPointAmount: action.payload,
    }))
})

export const selectTravelCardAmount = state => state.cart.travelCardAmount

export const selectLoyaltyPointsAmount = state => state.cart.loyaltyPointAmount
